import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WhatsappToggleComponent } from './whatsapp-toggle.component';
import { FrontendIconsModule } from '@tablesready/frontend-icons';

const COMPONENTS = [
  WhatsappToggleComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    FormsModule,
    FrontendIconsModule,
  ],
  exports: [...COMPONENTS],
})
export class WhatsappToggleModule { }
